import * as React from 'react';
import SimpleMDEReact from "react-simplemde-editor";
import * as SimpleMDE from "easymde";
import "easymde/dist/easymde.min.css";
import "./MarkdownTextArea.css"

export interface IMarkdownTextAreaProps {
    textValue: string;
    onChange?(value: string): void
}

export interface IMarkdownTextAreaState {
    textValue: string
}

export default class MarkdownTextArea extends React.Component<IMarkdownTextAreaProps, IMarkdownTextAreaState> {

  constructor(props: any) {
    super(props);

    this.state = {
            textValue: props.textValue.replace('<sup>', '').replace('</sup>', ''),
        };
    }

    handleChange = (value: string) => {
        this.setState({
        textValue: value
        });
        if (this.props.onChange) {
            this.props.onChange(value);
        }
    };

    render() {

        return (
            <div className="container container-narrow">
            <SimpleMDEReact
                className={""}
                label=""
                value={this.state.textValue}
                onChange={this.handleChange}
                options={{
                    autofocus: false,
                    spellChecker: false,
                    status: false,
                    toolbar:
                    [
                        {
                            name: "bold",
                            action: SimpleMDE.toggleBold,
                            className: "fa fa-bold",
                            title: "Bold",
                        },
                        {
                            name: "italic",
                            action: SimpleMDE.toggleItalic,
                            className: "fa fa-italic",
                            title: "Italic",
                        },
                        {
                            name: 'unordered-list',
                            action: SimpleMDE.toggleUnorderedList,
                            className: 'fa fa-list-ul',
                            title: 'Generic List',
                        },
                        {
                            name: 'ordered-list',
                            action: SimpleMDE.toggleOrderedList,
                            className: 'fa fa-list-ol',
                            title: 'Numbered List',
                        },
                        {
                            name: "custom",
                            action: function customFunction(editor){

                                var cm:any = editor.codemirror;
                                cm.replaceSelection("®");

                            },
                            className: "fa fa-registered",
                            title: "Registered Trademark",
                        },
                        {
                            name: "custom",
                            action: function customFunction(editor){

                                var cm:any = editor.codemirror;
                                cm.replaceSelection("™");

                            },
                            className: "fa fa-trademark",
                            title: "Trademark",
                        },
                        "|"
                    ],
                }}
            />
        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/MarkdownTextArea/MarkdownTextArea.tsx